module.exports = __webpack_public_path__ + "media/images/countrysquared/la-d368636f9404eadbdfdf3b5bef1c6e21.svg";